import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

import Layout from '@/components/Layout/Layout'
import { ToastProvider, ConfirmProvider } from '@/components/ui'
import { SelectedTalentProvider } from '@/hooks/useSelectedTalent'
import { isLoggedIn } from '@/lib/auth'
import DashboardPage from '@/pages/DashboardPage'
import SourcesPage from '@/pages/SourcesPage'
import ResumesPage from '@/pages/ResumesPage'
import NotionPage from '@/pages/NotionPage'
import JobMatchesPage from '@/pages/JobMatchesPage'
import CoverLettersPage from '@/pages/CoverLettersPage'
import PortfoliosPage from '@/pages/PortfoliosPage'
import InterviewScriptsPage from '@/pages/InterviewScriptsPage'
import SettingsPage from '@/pages/SettingsPage'
import LoginPage from '@/pages/LoginPage'

/** Wraps Layout with an auth gate — redirects to /login when no JWT. */
function ProtectedRoute() {
  if (!isLoggedIn()) return <Navigate to="/login" replace />
  return (
    <SelectedTalentProvider>
      <Layout />
    </SelectedTalentProvider>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <ConfirmProvider>
          <Routes>
      {/* Public — login sits outside Layout + auth gate */}
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route index element={<DashboardPage />} />
        <Route path="talents/:talentId/sources" element={<SourcesPage />} />
        <Route path="talents/:talentId/resumes" element={<ResumesPage />} />
        <Route path="talents/:talentId/notion" element={<NotionPage />} />
        <Route path="talents/:talentId/job-matches" element={<JobMatchesPage />} />
        <Route path="talents/:talentId/cover-letters" element={<CoverLettersPage />} />
        <Route path="talents/:talentId/portfolios" element={<PortfoliosPage />} />
        <Route path="talents/:talentId/interview-scripts" element={<InterviewScriptsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
          </Routes>
        </ConfirmProvider>
      </ToastProvider>
    </BrowserRouter>
  )
}
